import styled from "styled-components"
import { desktopTextStyles, mobileTextStyles } from "./typography.styles"
import Breakpoints from "./breakpoints"

export const TitleBlock = styled.h2`
  display: flex;
  ${mobileTextStyles.MobileHeadingTwoBold}
  color: var(--dark-mode-body-grey);
  background-color: ${props => props.backgroundColor || "var(--tricorn-black)"};
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: 32px 0px;

  @media (min-width: ${Breakpoints.md}) {
    ${mobileTextStyles.MobileHeadingTwoSemiBold}
    padding: 24px 0px;
    letter-spacing: 0.08em;
    background-color: var(--tricorn-black);
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingTwoRegular}
    padding: 32px 0px;
  }
`
